<template>
  <div class="ts-date-picker__wrapper">
    <v-menu :close-on-content-click="false" offset-y min-width="0">
      <v-date-picker
          v-model="dateRange[0]"
          locale="ko-kr"
      ></v-date-picker>
      <v-date-picker
          v-model="dateRange[1]"
          locale="ko-kr"
      ></v-date-picker>
      <template v-slot:activator="{on}">
        <v-text-field
            :value="dateRange.join('~')" v-on="on"
            class="ts-date-picker" label="Date range" readonly dense hide-details
        >
          <template v-slot:prepend-inner>
            <v-btn icon @click="moveDate(-1)" x-small><v-icon>mdi-chevron-left</v-icon></v-btn>
          </template>
          <template v-slot:append>
            <v-btn icon @click="moveDate(1)"  x-small><v-icon>mdi-chevron-right</v-icon></v-btn>
          </template>
          <template v-slot:append-outer>
            <v-text-field
                v-model="unitDelta"
                class="ts-date-picker__unit" dense hide-details
                type="number" label="Unit" min="1"
                @input="setDate"
            >
              <template v-slot:append>
                <v-btn icon x-small @click="() => {unit = units[(units.indexOf(unit)+1) % (units.length)]; setDate()}">
                  {{$t(`day-unit.${unit}`)}}
                </v-btn>
              </template>
            </v-text-field>
            <v-btn v-if="$mq !== 'mobile'" @click="setDate(0)">오늘</v-btn>
            <v-btn v-if="$mq !== 'mobile'" @click="setDate(1)">분기</v-btn>
            <v-btn :small="$mq === 'mobile'" @click="setDate(-1)">전체</v-btn>
          </template>
        </v-text-field>
      </template>
    </v-menu>
  </div>
</template>

<style lang="scss">
  /* TsDatePicker */
  .ts-date-picker{
    align-items:center;

    >* {
      margin:0;
      align-items: center;
    }

    .mobile &.v-input{
      flex-wrap:wrap;
      .v-input__append-outer {
        margin-top: 15px;
        flex-basis:100%;
      }
    }

    &__unit{
      width: 80px;
    }
  }
</style>

<script>
export default {
  name: "TsDatePicker",
  data() {
    return {
      dateRange: [],
      unit: 'week',
      units: ['day','week','month','year'],
      unitDelta: 1
    }
  },
  watch: {
    dateRange:{
      deep:true,
      handler(){
        this.$emit('change',this.dateRange)
      }
    }
  },
  created() {
    this.setDate()
  },
  methods: {
    moveDate(delta){
      this.dateRange = [
        this.$day(this.dateRange[0]).add(delta*this.unitDelta,this.unit).dateFormat(),
        this.$day(this.dateRange[1]).add(delta*this.unitDelta,this.unit).dateFormat()
      ]
    },
    setDate(option){
      let end = this.$day(this.dateRange[1] || undefined)
      switch (option) {
        case -1: return this.dateRange = []
        case 0: // 오늘
          end = this.$day()
          this.unitDelta = 1
          this.unit = 'day'
          break
        case 1: // 분기
          this.unitDelta = 3
          this.unit = 'month'
          end = end.set('date',1).set('month', Math.floor(end.get('month')/3)*3).add(3,'month').add(-1,'day')
      }
      this.dateRange = [end.add(-this.unitDelta, this.unit).add(1,'day').dateFormat(),end.dateFormat()]
    },
  }
}
</script>